import { MenuPermission } from 'components/layout/components/menu/types'

export interface UserData {
  name: string
  permissions: Array<string>
}

export interface AuthContextData {
  logged: boolean | null
  user: UserData | null
  theme: Theme | null
  login(values: LoginRequest): Promise<void>
  logout(): void
  setTheme: React.Dispatch<React.SetStateAction<Theme | null>>
  getMenuPermission(): MenuPermission
}

export interface LoginRequest {
  login: string
  password: string
}

export enum Theme {
  Light = 'Light',
  Dark = 'Dark',
}
